<sgt-multi-select
  #multiSelectRef
  [options]="selectorOptions"
  [ngModel]="value"
  (ngModelChange)="onSelectionChange()"
  [settings]="settings"
  [variante]="variante"
  [icon]="iconePorPerfil"
  (search)="search.emit($event)"
  (isFirstOpened)="onFirstOpened($event)"
>
</sgt-multi-select>
